<div class="d-flex flex-column flex-root">
	<div class="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid">
		<div class="login-aside d-flex flex-column flex-row-auto"
			style="box-shadow: inset -10px 0px 10px -10px rgba(0,0,0,0.5);">
			<div class="aside-img d-flex flex-row-fluid">
				<img src="assets/images/FPC.png" alt="FPC Image">
				<div class="caption">Veterinary Management</div>
			</div>
		</div>
		<div class="login-content flex-row-fluid d-flex flex-column p-10">
			<div class="d-flex flex-row-fluid flex-center">
				<div class="login-form">
					<div class="login-content flex-row-fluid d-flex flex-column">
						<a href="#" class="login-logo pb-xl-15 pb-10">
							<span style="font-size:4rem;font-weight:600;color:#414e91 !important">Univet</span>
						</a>
					</div>
					<h6>Forgot Password</h6>

					<form [formGroup]="_requestCodeForm" *ngIf="!codeSent">
						<div class="form-group">
							<input type="email" formControlName="Email" id="Email"
								class="form-control h-auto py-4 px-8 font-size-h6" placeholder="Email" required
								autofocus autocomplete="off" (keyup.enter)="sendCode()">
							<div *ngIf="clicked && requestForm.controls.Email.invalid" class="invalid-feedback d-block">
								Please enter a valid email
							</div>
						</div>
						<div class="form-group">
							<button type="button" class="btn btn-lg btn-block btn-success font-weight-bold font-size-h6"
								[disabled]="isSendingCode" style="background-color:#182845" (click)="sendCode()">
								{{ isSendingCode ? 'Sending code...' : 'Send Reset Code' }} &nbsp;<i
									*ngIf="isSendingCode" class="fas fa-spinner fa-spin"></i>
							</button>
						</div>
						<div class="form-group text-center">
							<a href="javascript:;" class="text-success" style="color:#98a7e8 !important"
								(click)="backToLogin()">Back to Sign In</a>
						</div>
					</form>

					<form [formGroup]="_resetPasswordForm" *ngIf="codeSent">
						<div class="form-group">
							<input type="text" formControlName="Code" id="Code"
								class="form-control h-auto py-4 px-8 font-size-h6" placeholder="Reset code from email"
								required autofocus autocomplete="off">
							<div *ngIf="clicked && resetForm.controls.Code.invalid" class="invalid-feedback d-block">
								Required
							</div>
						</div>
						<div class="form-group">
							<input type="password" formControlName="Password" id="Password"
								class="form-control h-auto py-4 px-8 font-size-h6" placeholder="New Password"
								required autocomplete="off">
							<div *ngIf="clicked && resetForm.controls.Password.invalid" class="invalid-feedback d-block">
								Required
							</div>
						</div>
						<div class="form-group">
							<input type="password" formControlName="ConfirmPassword" id="ConfirmPassword"
								class="form-control h-auto py-4 px-8 font-size-h6" placeholder="Confirm Password"
								required autocomplete="off" (keyup.enter)="resetPassword()">
							<div *ngIf="clicked && resetForm.controls.ConfirmPassword.invalid" class="invalid-feedback d-block">
								Required
							</div>
						</div>
						<div class="form-group">
							<button type="button" class="btn btn-lg btn-block btn-success font-weight-bold font-size-h6"
								[disabled]="isResettingPassword" style="background-color:#182845" (click)="resetPassword()">
								{{ isResettingPassword ? 'Resetting...' : 'Reset Password' }} &nbsp;<i
									*ngIf="isResettingPassword" class="fas fa-spinner fa-spin"></i>
							</button>
						</div>
						<div class="form-group text-center">
							<a href="javascript:;" class="text-success" style="color:#98a7e8 !important"
								(click)="backToLogin()">Back to Sign In</a>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>
